import React from 'react'
import Studentprofile from '../../components/student/studentprofile'
export default function Profile() {
  return (
    <div>
        <Studentprofile/>
    </div>
  )
}
